var Interventions = {
    categories: [],
    textPositioned: false,

    init: function() {
        Interventions.bindSlider();
        if (typeof categories !== 'undefined') {
            Interventions.categories = JSON.parse(categories);
        }
        //Interventions.positionText();
        Interventions.bindSubmit();
    },

    bindSubmit: function() {
        $('#supportSubmit').click(function(e) {
            e.preventDefault();
            var form = $('#supportForm');
            var url = form.attr('action');
            var data = form.serialize();
            $.post(url, data, function(response) {
               if (!response['success']) {
                   alert('Action not successful, please try again.');
                   return false;
               }
               alert('Support successfully updated!');
               $('#supportModal').modal('toggle');
               window.location.reload();
            });
        });
    },

    positionText:function() {
        var input = $('#score');
        var text = $('#supportCategory');
        var score = input.val();
        var width = 500;
        var offset = -54;
        var unit = width / max;
        var position = (width / 2) + offset;
        text.css({'left':position + 'px'});

        if (score != 0) {
            position = unit * score + offset;
            text.css({'left':position + 'px'});
        }
        Interventions.textPositioned = true;
        $('#supportModal').on('show.bs.modal', function() {
            if (!Interventions.textPositioned) {

            }
        });
    },

    bindSlider: function() {
        $('#score').on('input', function() {
            var input = $(this);
            var val = input.val();
            var text = $('#supportCategory');
            var string = Interventions.categories[val];
            text.html(string);
        });
    },
}